import { EditorTools } from '@progress/kendo-react-editor';

const CustomFontSizeToolSettings = {
  style: 'font-size',
  defaultItem: {
    text: '12',
    value: '12px'
  },
  items: [{
    text: '14',
    value: '14px'
  }, {
    text: '18',
    value: '18px'
  }, {
    text: '22',
    value: '22px'
  }, {
    text: '32',
    value: '32px'
  }]
};

const FontSizeTool = EditorTools.createStyleDropDownList(CustomFontSizeToolSettings);
export default FontSizeTool;
